import { useEffect, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const match = window.location.hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;

    (async () => {
      if (!sessionId) {
        window.location.replace("/admin");
        return;
      }
      try {
        await axios.post(
          `${API}/auth/session`,
          {},
          { headers: { "X-Session-ID": sessionId }, withCredentials: true }
        );
        const saved = sessionStorage.getItem("admin_return_search");
        sessionStorage.removeItem("admin_return_search");
        window.location.replace(`/admin${saved || ""}`);
      } catch (e) {
        const code = e?.response?.status === 403 ? "unauthorised" : "failed";
        window.location.replace(`/admin?error=${code}`);
      }
    })();
  }, []);

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-[#F8F8F5] flex items-center justify-center">
      <p className="font-body text-sm text-[#A1A1AA]">Signing you in…</p>
    </div>
  );
}
